import * as React from 'react';

import Layout from 'components/Layout';
import SEO from 'components/SEO';

import Hero from 'pageComponents/Trust/Hero';
import TrustBody from 'pageComponents/Trust/TrustBody';

const TrustPage = () => {
  return (
    <Layout>
      <Hero />
      <TrustBody />
    </Layout>
  );
};

export default TrustPage;

export function Head({ location }) {
  return (
    <SEO
      title="Security, Reliability, Compliance, and Privacy"
      description="Your trust is important to us. Sleuth encrypts data at rest and in transit, provides SSO, 2FA, and more, are compliant with SOC2 and GDPR, and values privacy."
      location={location}
    />
  );
}
